import { ExpandableSection } from "../ExpandableSection";
import { Table } from "../Table";
import numeral from "numeral";
import { gaMediaTitleLabels } from "@commercial-publishing/shared-types/report";

const PageviewsSection = ({ items, classes }) =>
  items?.length > 0 && (
    <ExpandableSection title="Pageviews per Media Title" classes={classes}>
      <Table
        classes={classes}
        columns={tableColumns}
        items={items.toSorted(
          (a, b) => b.value.screenPageViews - a.value.screenPageViews,
        )}
        keyField="key"
      />
    </ExpandableSection>
  );

const tableColumns = [
  {
    xs: 6,
    sm: 6,
    md: 6,
    label: "Media Title",
    field: "key",
    render: (data) => gaMediaTitleLabels[data.key] || data.key,
  },
  {
    xs: 3,
    sm: 3,
    md: 3,
    label: "Pageviews",
    field: "screenPageViews",
    render: (data) => data.value?.screenPageViews || 0,
  },
  {
    xs: 3,
    sm: 3,
    md: 3,
    label: "Avg Time on Page",
    field: "averageSessionDuration",
    render: (data) =>
      `${data.value?.averageSessionDuration ? numeral(data.value.averageSessionDuration).format("0.0") : 0}s`,
  },
];

export default PageviewsSection;
